import ChartNivWegrakingen from "../../../../src/client/niv_acuteboekje/json/wegrakingen.json";
import ChartNivSchematic from "../../../../src/client/niv_acuteboekje/interactions/chart_schematic/ChartNivSchematic";
import * as React from 'react';
export default {
  ChartNivWegrakingen,
  ChartNivSchematic,
  React
};